<span>{{
  'QualityManagement::AssignmentDueDateApproachingNotification'
    | abpLocalization: assignmentName:dueDate
}}</span>
